/** Verrou synchrone — bloque la sync IMAP live pendant send-message.php. */
let outboxSendInFlight = false;

export function isOutboxSendInFlight(): boolean {
  return outboxSendInFlight;
}

export function setOutboxSendInFlight(active: boolean): void {
  outboxSendInFlight = active;
}
